import './filedrop.css';
import styles from './styles.module.scss'

import axios from 'axios';
import isEmail from 'validator/lib/isEmail';
import { FileDrop } from 'react-file-drop';

import { Input, Button } from 'antd';

import { Helmet } from 'react-helmet';
import { useState, useEffect } from 'react';

export const PageApk = () => {
  const [downloadAvailable, setDownloadAvailable] = useState(false)

  const [googleServicesJson, setGoogleServicesJson] = useState<undefined|any>(undefined)
  const [email, setEmail] = useState<undefined|string>(undefined)

  useEffect(() => {
    if (!googleServicesJson) {
      setDownloadAvailable(false)
      return
    }

    if (!email || !isEmail(email || '')) {
      setDownloadAvailable(false)
      return
    }

    setDownloadAvailable(true)
    return () => { }
  }, [googleServicesJson, email])

  const onEmailChange = (e: any) => {
    setEmail(e.target.value)
  }

  const onDownloadClick = async (e: React.MouseEvent) => {
    setDownloadAvailable(false)

    if (!googleServicesJson) {
      alert('구글 서비스 JSON 파일이 올바르지 않습니다.')
      return
    }

    const validateEmail = isEmail(email!)

    if (!validateEmail) {
      alert('이메일이 올바르지 않습니다.')
      return
    }

    const project_number = googleServicesJson?.project_info?.project_number

    console.log('project_number', project_number)

    if (!project_number) {
      alert('구글 서비스 JSON 파일이 올바르지 않습니다.')
      return
    }

    console.log(project_number)
    console.log(googleServicesJson, email)
    console.log(email)

    try {
      const githubActionResult = await axios.post('https://us-central1-turtle-books.cloudfunctions.net/generateApkAndSendEMail', {
        google_services: JSON.stringify(googleServicesJson),
        project_number,
        user_email: email,
        timestamp: Date.now()
      })
      alert('APK 생성 신청이 완료되었습니다. 잠시 후 메일을 확인해주세요.')
    } catch(e) {
      alert('APK 생성에 실패했습니다.')
    }
  }

  return (
    <>
      <Helmet>
        <title>고객을 끌어오는 구글 애널리틱스4 - APK 다운로드</title>
      </Helmet>
      <div className={styles.header}>
        <h2>APK 다운로드</h2>
      </div>
      <div className={styles.description}>
        <p>구글 서비스 JSON 정보와 이메일을 입력해주세요</p>
        <p>당분간 저자가 직접 APK를 생성하여 이메일로 전달드립니다. 현재 APK 자동 생성 시스템에 문제가 발견되었기 때문입니다.</p>
        <p>늦어도 1시간 이내에 APK를 전달드릴 수 있도록 노력하겠습니다.</p>
        <p>APK 자동 시스템은 곧 정상화할 예정입니다. 감사합니다.</p>
        {/* <p>APK 생성 및 전달에는 10분 가량 걸릴 수 있습니다.</p> */}
      </div>
      <div className={styles.body}>
        <div className={`row-file-drop ${styles.rowFileDrop}`} data-has-json={googleServicesJson !== undefined}>
          <FileDrop
            // onFrameDragEnter={(event) => console.log('onFrameDragEnter', event)}
            // onFrameDragLeave={(event) => console.log('onFrameDragLeave', event)}
            // onFrameDrop={(event) => console.log('onFrameDrop', event)}
            // onDragOver={(event) => console.log('onDragOver', event)}
            // onDragLeave={(event) => console.log('onDragLeave', event)}
            onDrop={(files, event) => {
              if (!files) { return }

              const file = files[0];
              if (!file) { return }

              const { name: fileName, type: fileType } = file

              if (!fileName.includes('google-services.json') || !fileType.includes('application/json')) {
                alert('파일이 올바르지 않습니다.')
                return
              }

              const reader = new FileReader();
              reader.onload = (progressEvent) => {
                // @ts-ignore
                const result: string = progressEvent.target.result

                if (!result.includes('project_id')) {
                  alert('파일이 올바르지 않습니다.')
                  return
                }

                const asJson = JSON.parse(result)
                setGoogleServicesJson(asJson)
              };
              reader.readAsText(file);
            }}
          >
            {
              !googleServicesJson && (
                <>구글 서비스 JSON 파일을 드래그해주세요.</>
              )
            }
            {
              googleServicesJson && (
                <>구글 서비스 JSON 파일이 확인되었습니다.</>
              )
            }
          </FileDrop>
        </div>
        {/* <div className="row row-debug">
          {
            googleServicesJson && (
              <p>{JSON.stringify(googleServicesJson)}</p>
            )
          }
        </div> */}
        <div className={styles.rowEmail}>
          <Input
            size="large"
            placeholder="이메일 주소를 입력해주세요" value={email} onChange={(e) => onEmailChange(e)}/>
        </div>
        <div className={styles.rowDownload}>
          <Button
            className={styles.btnDownload}
            disabled={downloadAvailable === false}
            size="large"
            type="primary"
            onClick={(e) => onDownloadClick(e)}>다운로드</Button>
        </div>
      </div>
    </>
  )
}